import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
import styles from '../../boardOne/BragifyEmbed.module.css';
import { networks } from '../../consts';
import './EmbedModalContent.scss';
import ModalShareButtons from './ModalShareButtons';

const EmbedModalContent = ({
  item,
  copyVisible,
  shareURL,
  linkHandler,
  emailHandler,
  closeModal,
  options,
  index,
  embedType,
}) => {
  return (
    <>
      {item.service === networks.TIK_TOK && (
        <>
          <blockquote className="tiktok-embed gigg-tiktok-embed" data-video-id={item.id}>
            <section />
          </blockquote>
          {item.id && (
            <Helmet>
              <script src="https://www.tiktok.com/embed.js" />
            </Helmet>
          )}
        </>
      )}
      <button
        type="button"
        aria-label="close dialog"
        className={styles['bragify-modal-close']}
        onClick={closeModal}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <ModalShareButtons
        item={item}
        copyVisible={copyVisible}
        shareURL={shareURL}
        linkHandler={linkHandler}
        emailHandler={emailHandler}
        options={options}
        index={index}
        verticalAlign
        embedType={embedType}
      />
    </>
  );
};

export default EmbedModalContent;
